import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  alertTitle: () => __(translations.alertCloak.alertTitle, 'Alert!'),
  okay: () => __(translations.alertCloak.okay, 'Okay'),
  changesCommited: () => __(translations.alertCloak.changesCommited, 'Your changes has been saved successfully!'),
};
